module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('tooltip', {
    attrs: {
      "label": "Edit",
      "type": "default",
      "placement": "left"
    }
  }, [(parseInt(_vm.$store.state.config.user.level) < 99 || (parseInt(_vm.$store.state.config.user.level) === 99 && _vm.$store.state.config.user.admin)) ? _c('a', {
    staticClass: "button button-table is-small",
    on: {
      "click": function($event) {
        return _vm.edit()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-pencil"
  })]) : _vm._e()]), _vm._v(" "), _c('tooltip', {
    attrs: {
      "label": "Export User to EZConnect",
      "type": "default",
      "placement": "left"
    }
  }, [(parseInt(_vm.$store.state.config.user.level) < 99 && _vm.data.ezconnect_id === null && _vm.data.agency_ezconnect_id !== null) ? _c('a', {
    staticClass: "button button-table is-small",
    class: {
      'is-disabled': _vm.inProgress
    },
    on: {
      "click": function($event) {
        return _vm.exportCR()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-link"
  })]) : _vm._e()])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-1165baae","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./client/components/users/ClientTableButtons.vue
// module id = 1069
// module chunks = 39